import type { FunnelStatus } from '../../types'

interface StatusIndicatorProps {
  isActive: boolean
  status?: FunnelStatus
  showLabel?: boolean
  size?: 'sm' | 'md'
}

const STATUS_CONFIG: Record<FunnelStatus, { color: string; label: string }> = {
  active: { color: 'var(--fn-status-active)', label: 'Active' },
  draft: { color: '#3b82f6', label: 'Draft' },
  inactive: { color: 'var(--fn-status-inactive)', label: 'Inactive' },
}

export function StatusIndicator({ isActive, status, showLabel = true, size = 'md' }: StatusIndicatorProps) {
  const dotSize = size === 'sm' ? 'w-1.5 h-1.5' : 'w-2 h-2'
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm'
  const resolvedStatus: FunnelStatus = status ?? (isActive ? 'active' : 'inactive')
  const config = STATUS_CONFIG[resolvedStatus]

  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className={`${dotSize} rounded-full flex-shrink-0`}
        style={{ backgroundColor: config.color }}
      />
      {showLabel && (
        <span
          className={`${textSize} font-medium`}
          style={{ color: config.color }}
        >
          {config.label}
        </span>
      )}
    </span>
  )
}
